import { defineMessages } from 'react-intl';

export default defineMessages({
  homePage: {
    id: 'homePage',
    defaultMessage: 'Home'
  },
  accountPage: {
    id: 'accountPage',
    defaultMessage: 'Account'
  },
  ordersPage: {
    id: 'ordersPage',
    defaultMessage: 'Orders'
  },
  rnaOligosPage: {
    id: 'rnaOligosPage',
    defaultMessage: 'Custom RNA Oligos'
  }
});
